import React from 'react';
import CustomDropdown from './CustomDropdown';

// Badge styling helper
const getBadgeClass = (type, value) => {
  if (type === 'priority') {
    switch (value?.toLowerCase()) {
      case 'critical': return 'bg-red-500/20 text-red-400 border-red-500/30';
      case 'high': return 'bg-red-500/20 text-red-400 border-red-500/30';
      case 'medium': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      case 'low': return 'bg-green-500/20 text-green-400 border-green-500/30';
      default: return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
    }
  }
  if (type === 'domain') {
    switch (value?.toLowerCase()) {
      case 'software': return 'bg-purple-500/20 text-purple-400 border-purple-500/30';
      case 'electronics': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
      case 'mechanical': return 'bg-orange-500/20 text-orange-400 border-orange-500/30';
      case 'management': return 'bg-pink-500/20 text-pink-400 border-pink-500/30';
      default: return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
    }
  }
  if (type === 'status') {
    switch (value?.toLowerCase()) {
      case 'new': return 'bg-blue-500/20 text-blue-400 border-blue-500/30';
      case 'under_discussion': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      case 'solution_decided': return 'bg-indigo-500/20 text-indigo-400 border-indigo-500/30';
      case 'in_progress': return 'bg-orange-500/20 text-orange-400 border-orange-500/30';
      case 'completed': return 'bg-green-500/20 text-green-400 border-green-500/30';
      case 'in progress': return 'bg-orange-500/20 text-orange-400 border-orange-500/30';
      case 'not decided': return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
      case 'pending': return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      default: return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
    }
  }
  return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
};

const BadgeDropdown = ({ 
  value, 
  onChange, 
  options, 
  type, // 'priority', 'domain', or 'status'
  placeholder = "Select...",
  className = "",
  disabled = false,
  showAllOption = false
}) => {
  // Add "All" option if requested
  const allOptions = showAllOption 
    ? [{ value: 'all', label: `All ${type}s` }, ...options]
    : options;

  const renderBadge = (option) => {
    if (option.value === 'all') {
      return <span className="text-gray-300">{option.label}</span>;
    }
    
    const badgeClass = getBadgeClass(type, option.value);
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium border ${badgeClass}`}>
        {option.label}
      </span>
    );
  };

  return (
    <CustomDropdown
      value={value}
      onChange={onChange}
      options={allOptions}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      renderOption={renderBadge}
      renderSelected={renderBadge}
    />
  );
};

export default BadgeDropdown;